module.exports = __webpack_public_path__ + "static/media/20180523-LCS-035-23.5349adf9.jpg";